import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Text,
  Spinner,
  Input,
  Button,
  useToast,
  Heading,
  List,
  ListItem,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as mod from "../../url";
import { modules, formats } from "../../utils/quillModules"; // you should have these
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
const SIDEBAR_WIDTH = "250px";
const draftTypes = [
  "Agreements & Contracts",
  "Corporate & Commercial Law",
  "Litigation & Dispute Resolution",
  "Property & Real Estate",
  "Family & Personal Law",
  "Constitutional Amendment",
  "Criminal Law",
  "Consumer & Insurance Matters",
  "Banking, Finance & Taxation",
  "Labour & Employment Law",
  "Intellectual Property Rights (IPR)",
  "Arbitration & ADR",
  "Government & Administrative Law",
  "Affidavits, Declarations & Notices",
  "Court Applications & Petitions",
];
const UpdateDraft = () => {
  const { slug } = useParams();
  const [draft, setDraft] = useState(null);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const editorRef = useRef(null);
  const toast = useToast();
  const token = JSON.parse(sessionStorage.getItem("superAdminLawvs"))?.data
    ?.token;
  const config = { headers: { Authorization: token } };

  useEffect(() => {
    const fetchDraft = async () => {
      try {
        const { data } = await axios.get(
          `${mod.api_url}/api/v1/draft/get_drafts/${slug}`,
          {
            config,
          }
        );
        setDraft(data);
        setTitle(data.title);
        setContent(data.des);
        setSubTitle(data.subTitle);
      } catch (error) {
        console.error("Failed to fetch draft", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDraft();
  }, [slug]);

  const handleUpdate = async () => {
    setUpdating(true);
    try {
      let htmlContent = content;

      // ✅ Replace multiple consecutive spaces with &nbsp; for proper spacing
      htmlContent = htmlContent.replace(/  /g, "&nbsp;&nbsp;");

      // Optional: replace tabs with 4 spaces
      htmlContent = htmlContent.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");

      await axios.put(
        `${mod.api_url}/api/v1/draft/Update_drafts/${slug}`,
        { title, des: htmlContent, subTitle },
        config
      );

      toast({
        title: "Draft updated",
        description: "The draft has been updated successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Update error:", error);
      toast({
        title: "Update failed",
        description: "Something went wrong while updating the draft.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUpdating(false);
    }
  };

  if (loading) return <Spinner size="xl" mt="100px" />;

  if (!draft)
    return (
      <Text color="red.500" mt="100px">
        Draft not found
      </Text>
    );

  const handleChange = (e) => {
    const value = e.target.value;
    setSubTitle(value);

    if (value.length > 0) {
      const results = draftTypes?.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (value) => {
    setSubTitle(value);
    setFiltered([]);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="100px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={2}>
        <Heading fontSize="2xl" mb={4} size="md" bg="#D29B3F" p={3}>
          {" "}
          Update Draft
        </Heading>

        <Input
          placeholder="Title"
          mb={4}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Box position="relative" width="300px">
          <Input
            placeholder="Types of draft"
            value={subTitle}
            onChange={handleChange}
            mb={2}
          />

          {filtered?.length > 0 && (
            <Box
              position="absolute"
              width="100%"
              bg="white"
              boxShadow="md"
              borderRadius="md"
              zIndex="10"
              maxHeight="150px"
              overflowY="auto"
            >
              <List spacing={0}>
                {filtered?.map((item, index) => (
                  <ListItem
                    key={index}
                    px={4}
                    py={2}
                    cursor="pointer"
                    _hover={{ bg: "gray.100" }}
                    onClick={() => handleSelect(item)}
                  >
                    <Text>{item}</Text>
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Box>
        {/* quill */}
        <ReactQuill
          className="custom-quill"
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          theme="snow"
          placeholder="Write your draft description here..."
          style={{ height: "60vh", marginBottom: "20px" }}
        />
        {/* TinyMCE */}

        <Button
          colorScheme="blue"
          onClick={handleUpdate}
          isLoading={updating}
          mt={4}
        >
          Update Draft
        </Button>
      </Box>
    </>
  );
};

export default UpdateDraft;
